import { IMappers } from '../../../repositories/billing-payments/v3/check-payment';
import { IYandexPaymentStatus, EYandexPaymentStatus } from './types';

export const mappers: IMappers<IYandexPaymentStatus, IYandexPaymentStatus> = {
  200: ({ status }) => ({ status: status as unknown as EYandexPaymentStatus }),
  400: ({ message }) => ({ status: EYandexPaymentStatus.PENDING, message }),
};
